export default __webpack_public_path__ + "static/media/profile1.3fe0d14e.svg";